import { createSlice, createAction } from '@reduxjs/toolkit';

export const downloadInvoice = createAction('DOWNLOAD_INVOICE');
export const getPastTransactions = createAction('GET_PAST_TRANSACTIONS');

const initialState = {
  // Download invoice state
  downloadingInvoice: false,
  downloadUrl: null,
  invoiceFilename: null,
  downloadError: null,
  downloadSuccess: false,
  
  // Past transactions state
  loadingTransactions: false,
  transactions: [],
  transactionsError: null,
  hasMore: false,
  nextKey: null,
  count: 0,
};

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    // Download invoice reducers
    downloadInvoiceRequest: (state) => {
      state.downloadingInvoice = true;
      state.downloadError = null;
      state.downloadSuccess = false;
    },
    downloadInvoiceSuccess: (state, action) => {
      state.downloadingInvoice = false;
      state.downloadUrl = action.payload.downloadUrl;
      state.invoiceFilename = action.payload.invoiceFilename;
      state.downloadSuccess = true;
    },
    downloadInvoiceFailure: (state, action) => {
      state.downloadingInvoice = false;
      state.downloadError = action.payload;
      state.downloadSuccess = false;
    },
    resetInvoiceDownload: (state) => {
      state.downloadUrl = null;
      state.invoiceFilename = null;
      state.downloadingInvoice = false;
      state.downloadError = null;
      state.downloadSuccess = false;
    },

    // Past transactions reducers
    getPastTransactionsRequest: (state) => {
      state.loadingTransactions = true;
      state.transactionsError = null;
    },
    getPastTransactionsSuccess: (state, action) => {
      state.loadingTransactions = false;
      state.transactions = action.payload.transactions;
      state.hasMore = action.payload.hasMore;
      state.nextKey = action.payload.nextKey;
      state.count = action.payload.count;
    },
    getPastTransactionsFailure: (state, action) => {
      state.loadingTransactions = false;
      state.transactionsError = action.payload;
      state.transactions = [];
    },
  },
});

export const {
  downloadInvoiceRequest,
  downloadInvoiceSuccess,
  downloadInvoiceFailure,
  resetInvoiceDownload,
  getPastTransactionsRequest,
  getPastTransactionsSuccess,
  getPastTransactionsFailure,
} = invoiceSlice.actions;

export default invoiceSlice.reducer;
